<template>
  <label
    :style="style"
    :for="id"
    class="flex items-center cursor-pointer select-none"
    :class="{ 'opacity-50': disabled }"
  >
    <input
      class="flex-shrink-0 w-5 h-5 border border-gray-300 rounded-full appearance-none cursor-pointer"
      :class="{ checked }"
      type="radio"
      :id="id"
      :checked="checked"
      :value="value"
      :disabled="isDisabled"
      @change="$emit('change', value)"
    />
    <span class="ml-2"><slot></slot></span>
  </label>
</template>

<script>
export default {
  props: ["modelValue", "value", "id", "disabled"],
  model: {
    prop: "modelValue",
    event: "change",
  },
  computed: {
    checked() {
      return this.modelValue == this.value;
    },
    isDisabled() {
      return this.disabled ? "disabled" : null;
    },
    style() {
      const color =
        this.$store.state.config?.colors?.primaryOptionColor || "#51B44F";
      return {
        "--bg-image": `url(
          "data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18'%3E%3Cpath d='M17.5 9a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z' fill='%23fff' stroke=''/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9 15A6 6 0 109 3a6 6 0 000 12z' fill='${color.replace(
            "#",
            "%23"
          )}'/%3E%3C/svg%3E"
        )`,
        "--border-color": color,
      };
    },
  },
};
</script>

<style scoped>
.checked {
  border-color: var(--border-color);
  background-image: var(--bg-image);
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: center center;
}
</style>
